import React from 'react'

import Wrapper, { DefaultButton } from './Wrapper'
import forbidden from 'assets/images/forbidden.svg'

const image = <img src={forbidden} alt="forbidden" style={{ width: 564 }} />

const InAppNotForbidden = ({
  resourceName = 'channel',
  extraButton,
  isPersonal,
}) => (
  <Wrapper
    image={image}
    goBackButton={
      <div className="flexbox">
        {!isPersonal && extraButton}
        <DefaultButton />
      </div>
    }
    title={'Restricted access'}
    subtitle={`Sorry, you can't access this ${resourceName} :(`}
  >
    <div className="font-weight-medium shade-10 margin-bottom-large">
      Private channel
    </div>
    {!isPersonal && (
      <div>
        <span>To see this doc, request access to channel admins.</span>
        <br />
      </div>
    )}
  </Wrapper>
)

export default InAppNotForbidden
